export default {
  name: 'CodeCanyon',
  abbreviation: 'CC',
  domain: 'codecanyon.net',
  google_analytics_id: 'UA-11834194-12',
  google_remarketing_label: 'bdtlCM3-uQMQp-WC_AM',
  item_results_layout: 'list',
  home_search_placeholder: 'e.g. ecommerce plugin',
  assets_domains: {
    item_thumbnail: 'thumb-cc.s3.envato.com',
    item_image: 'image-cc.s3.envato.com'
  },
  filterOrder: [
    'category',
    'tags',
    'price',
    'software-version',
    'compatible-with',
    'sales',
    'rating',
    'date-added'
  ],
  features: {
    /**
     * @description Enable automatic sign-in for CodeCanyon
     * @author Foundation
     * @expires
     */
    'enable-auto-signin': true
  }
}
